import Constants from '@/Constants';
import EmptyState from '@/components/EmptyState';
import { useGroup } from '@/hooks/useGroup';
import http from '@/services/HttpService';
import { ApplicationState } from '@/store';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GroupCard } from '../GroupCard';
import './style.scss';

const ManagerGroup: React.FC = () => {
    const history = useHistory();
    const { strings } = useSelector((state: ApplicationState) => ({ strings: state.locale.data }));
    const applicationId: number = useSelector((state: ApplicationState) => state.appOrganization.data.application.id);
    const organizationId: number = useSelector((state: ApplicationState) => state.appOrganization.data.organization.id);
    const { response, loading, revalidateResult } = useGroup(applicationId, organizationId);

    const handleNewGroup = (): void => history.push('/group/create');

    const onRemoveGroup = (id: number) => {
        http.delete(`${Constants.GROUPS_RESULT_URI}/${id}`)
            .then(() => {
                toast.success(strings.toastMessages.GROUP_SAVE_SUCCESS);
                revalidateResult();
            })
            .catch(() => toast.error(strings.toastMessages.GROUP_SAVE_ERROR));
    };

    return (
        <div className="groups">
            {response && response.length !== 0 && (
                <button className="btn btn-primary" onClick={handleNewGroup}>
                    {strings.CREATE_GROUP}
                </button>
            )}
            <div className="list-groups-container">
                <h5 className="title">{strings.GROUP_LIST}</h5>
                {!loading && response && response.length > 0 && (
                    <div>
                        <GroupCard data={response} remove={(id) => onRemoveGroup(id)} />
                    </div>
                )}

                {!loading && response && response.length === 1 && (
                    <EmptyState emptyType={strings.EMPTY_GROUP} handleCTA={handleNewGroup} iconType="person" labelCTA={strings.CREATE_GROUP} />
                )}
            </div>
        </div>
    );
};

export default ManagerGroup;
